/**
 * One accent per hardware family, so a rail type is recognisable at a glance
 * in the technician console and on the room controls page.
 */
export const ACCENT = {
  SLATE: 'slate',
  AMBER: 'amber',
  VIOLET: 'violet',
  SKY: 'sky',
  TEAL: 'teal',
} as const;

export type AccentKey = (typeof ACCENT)[keyof typeof ACCENT];

export interface AccentSpec {
  /** Soft background for a filled channel tile. */
  readonly tile: string;
  /** Solid background for a legend dot or accent bar. */
  readonly dot: string;
  /** Accent text on a light background. */
  readonly text: string;
  /** Accent border for selected states. */
  readonly border: string;
}

export const ACCENT_SPECS = {
  [ACCENT.SLATE]: {
    tile: 'bg-slate-500/10',
    dot: 'bg-slate-500',
    text: 'text-slate-600',
    border: 'border-slate-300',
  },
  [ACCENT.AMBER]: {
    tile: 'bg-amber-500/10',
    dot: 'bg-amber-500',
    text: 'text-amber-700',
    border: 'border-amber-300',
  },
  [ACCENT.VIOLET]: {
    tile: 'bg-violet-500/10',
    dot: 'bg-violet-500',
    text: 'text-violet-700',
    border: 'border-violet-300',
  },
  [ACCENT.SKY]: {
    tile: 'bg-sky-500/10',
    dot: 'bg-sky-500',
    text: 'text-sky-700',
    border: 'border-sky-300',
  },
  [ACCENT.TEAL]: {
    tile: 'bg-teal-500/10',
    dot: 'bg-teal-500',
    text: 'text-teal-700',
    border: 'border-teal-300',
  },
} as const satisfies Record<AccentKey, AccentSpec>;
